import { NavLink } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const slides = [
  {
    eyebrow: "Edit Donna · SS26",
    title: "Lei,\ncon carattere.",
    subtitle: "Capi selezionati dei brand più desiderati. Fino al −70%.",
    cta: "Esplora Donna",
    href: "/donna",
    image:
      "https://images.pexels.com/photos/34284465/pexels-photo-34284465.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=940",
    align: "left" as const,
  },
  {
    eyebrow: "Edit Uomo · SS26",
    title: "Lui,\nessenziale.",
    subtitle: "Tailoring contemporaneo e icone streetwear. Fino al −70%.",
    cta: "Esplora Uomo",
    href: "/uomo",
    image:
      "https://images.pexels.com/photos/16921798/pexels-photo-16921798.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=940",
    align: "right" as const,
  },
];

export function EditorialSplit() {
  return (
    <section className="bg-stone-950">
      <div className="grid grid-cols-1 md:grid-cols-2">
        {slides.map((s) => (
          <NavLink
            key={s.href}
            to={s.href}
            className="group relative overflow-hidden block min-h-[60vh] sm:min-h-[70vh] md:min-h-[min(80vh,760px)]"
          >
            <img
              src={s.image}
              alt={s.title.replace("\n", " ")}
              className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-[1200ms] ease-out"
            />
            {/* Vignette + side gradient */}
            <div className="absolute inset-0 bg-gradient-to-t from-stone-950/85 via-stone-950/30 to-stone-950/40" />
            <div
              className={
                s.align === "left"
                  ? "absolute inset-0 bg-gradient-to-r from-stone-950/70 via-transparent to-transparent"
                  : "absolute inset-0 bg-gradient-to-l from-stone-950/70 via-transparent to-transparent"
              }
            />

            <div className="relative h-full flex flex-col justify-end p-6 sm:p-10 lg:p-16">
              <p className="text-emerald-400 text-[10px] sm:text-[11px] tracking-[0.3em] uppercase font-semibold mb-3 sm:mb-5">
                {s.eyebrow}
              </p>
              <h1
                className="text-white leading-[0.95] mb-4 sm:mb-6 whitespace-pre-line"
                style={{
                  fontSize: "clamp(2rem, 7vw, 5.5rem)",
                  fontWeight: 700,
                  letterSpacing: "-0.03em",
                }}
              >
                {s.title}
              </h1>
              <p className="text-stone-200 text-xs sm:text-base max-w-sm mb-5 sm:mb-8 leading-relaxed">
                {s.subtitle}
              </p>
              <span className="inline-flex items-center gap-2 text-white text-[10px] sm:text-[11px] tracking-[0.25em] uppercase font-semibold w-fit border-b border-white/40 pb-2 group-hover:border-emerald-400 group-hover:text-emerald-400 transition-colors">
                {s.cta}
                <ArrowUpRight className="size-3.5 sm:size-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </span>
            </div>
          </NavLink>
        ))}
      </div>
    </section>
  );
}
